module.exports = __webpack_public_path__ + "img/mouth-1-3.5f63759c.svg";